import _ from 'lodash';

import { GUID_REGEX } from 'constants/loanPipelines';
import {
  CONDITION_STATUS_OPEN,
  DRILLDOWN_PRIOR_TO_TYPES,
  LoanSummaryDrilldownParam,
  TaskAudience,
} from 'constants/loanSummaryDrilldown';

const isDrilldownPriorTo = value =>
  DRILLDOWN_PRIOR_TO_TYPES.includes(value) || (_.isString(value) && GUID_REGEX.test(value));

export const getTaskAudienceSearch = audience => {
  if (!Object.values(TaskAudience).includes(audience)) {
    return '';
  }

  return new URLSearchParams({
    [LoanSummaryDrilldownParam.TASK_AUDIENCE]: audience,
  }).toString();
};

export const getConditionDrilldownSearch = priorToType => {
  if (!isDrilldownPriorTo(priorToType)) {
    return '';
  }

  return new URLSearchParams({
    [LoanSummaryDrilldownParam.CONDITION_PRIOR_TO]: priorToType,
    [LoanSummaryDrilldownParam.CONDITION_STATUS]: CONDITION_STATUS_OPEN,
  }).toString();
};

export const parseTaskAudience = value =>
  Object.values(TaskAudience).includes(value) ? value : null;

export const parseConditionDrilldown = ({ priorToType, status }) => {
  if (!isDrilldownPriorTo(priorToType)) {
    return null;
  }

  return { priorToType, isOpenOnly: status === CONDITION_STATUS_OPEN };
};
